import {useQuery, useQueryClient} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {ConfEnv} from "../../config/config";
import {getUserWalletService} from "../../services/wallet/getUserWallet";

const useGetUserWallet = staleTime => {
  const query = useQueryClient();
  const [balance, setBalance] = useState();
  const [accounts, setAccounts] = useState([]);
  const [response, setResponse] = useState();
  const {data, isError, isLoading, isSuccess, refetch, error, isStale} = useQuery({
    queryKey: ["userWallet"],
    queryFn: getUserWalletService,
    staleTime: staleTime ?? 5 * (60 * 1000), // 5 mins,
  });

  useEffect(() => {
    if (isStale) {
      // console.log("[useGetUserWallet] => Fetch Balance");
      refetch();
    }
  }, [isStale]);

  useEffect(() => {
    if (data) {
      setResponse(data?.data.data);
    }
  }, [data]);

  useEffect(() => {
    if (response?.accounts) {
      setAccounts(response.accounts);
      // Set default currency balance (VES)
      setBalance(response.accounts.find(account => account.currency === ConfEnv.DEFAULT_CURRENCY));
    }
  }, [response?.accounts]);

  // Get account by currency
  const getAccountByCurrency = currencyCode => {
    return accounts.find(account => account.currency === currencyCode);
  };

  const invalidateQuery = () => {
    query.invalidateQueries({queryKey: ["userWallet"]});
  };

  const balanceFormated = () => {
    return balance?.formattedBalance || "Bs.0,00";
  };

  return {
    data: response,
    balance,
    accounts,
    getAccountByCurrency,
    isError,
    isLoading,
    refetch,
    isSuccess,
    error,
    balanceFormated,
    invalidateQuery,
  };
};

export default useGetUserWallet;
